import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import useList from "../Provider/hooks/useList";
import statuses from "../statuses";
import { LogItemStatusFC } from "./types";

const LogItemStatus: LogItemStatusFC = ({ status }) => {
  const { Icon, title, color } = statuses[status];
  const { isLoading } = useList();
  return (
    <Tooltip title={title}>
      <Icon color={isLoading ? "disabled" : color} />
    </Tooltip>
  );
};

export default LogItemStatus;
